import { EarnAssetDetailsResponse, EarnDetailsAsset, MerchantStatistics } from '../../types'
import {
  EARN_DETAILS_STATE,
  EarnDetailsLifecycleState,
  EarnDetailsReady,
  UseEarnDetailsDataHandlers,
} from '../../types/detailsState'
import { formatAPY, formatUsd } from '../../utils/utils'
import { useEarnDetailsQuery } from '../api/useEarnDetailsQuery'
import { useEarnStatisticsQuery } from '../api/useEarnStatisticsQuery'

export interface EarnDetailsBaseReady extends EarnDetailsReady {
  details: EarnAssetDetailsResponse
  merchantStatistics: MerchantStatistics | undefined
}

export type EarnDetailsBaseData = EarnDetailsLifecycleState | EarnDetailsBaseReady

export const useEarnDetailsBaseData = (
  portfolioId: string | undefined,
  { onDeposit, onWithdraw }: UseEarnDetailsDataHandlers
): EarnDetailsBaseData => {
  const { data, isLoading } = useEarnDetailsQuery(portfolioId)
  const { data: statistics, isLoading: isStatisticsLoading } = useEarnStatisticsQuery()

  if (isLoading) {
    return { detailsState: EARN_DETAILS_STATE.LOADING }
  }

  if (!data) {
    return { detailsState: EARN_DETAILS_STATE.NOT_FOUND }
  }

  const merchantStatistics = statistics?.currencies[data.asset]
  const assetWithPortfolio: EarnDetailsAsset = { ...data, portfolioId }

  return {
    detailsState: EARN_DETAILS_STATE.READY,
    details: data,
    merchantStatistics,
    asset: data.asset,
    walletId: data.walletId,
    earnRate: formatAPY(data.myEarnRate ?? 0),
    summary: {
      allocatedFunds: formatUsd(data.fundsOverview.allocatedFunds),
      unallocatedFunds: formatUsd(merchantStatistics?.merchantMovableBalance.amount),
    },
    isStatisticsLoading,
    onDeposit: () => onDeposit(assetWithPortfolio),
    onWithdraw: () => onWithdraw(assetWithPortfolio),
  }
}
